<div id="footer-latam" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
  <div class="footer-process">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-xs-height hidden-xs">
          <div class="footer-processCopy">
            <p class="footer-paragraph--copy">
              © 2019 LATAM Airlines Chile
            </p>
            <p class="footer-paragraph--copy footer-paragraph-line">Av. Américo Vespucio 901, Renca, Santiago de
              Chile</p>
          </div>
        </div>
        <div class="col-xs-12 col-xs-height hidden-xs">
          <img src="assets/images/Latam-logo_-v.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</div>
